/** @import {NewAccountProps} from './NewAccountTypes' */

import React from 'react';
import './newAccounts.scss';
import Button from '../Form/Button/Button';

function NewAccount(/** @type {NewAccountProps} */ { account }) {
    if (!account)
        return (<></>);

    return (
        <div className="newaccounts__item newaccounts__item__chink">
            {/* Show "New" tag for FISA product we're removing this for now but keeping it for the future product we just uncomment this and change the product name */}
            {/* {account.product === 'The Fixed Rate Cash ISA' && (
                <div className="fisa-new-tag-listing">
                    <span>New</span>
                </div>
            )} */}
            <h2 className="newaccounts__title">
                {account.product}
            </h2>
            {account.disabledMessage && <div className="newaccounts__body" style={{marginBottom: '12px'}}>
                <b>{account.disabledMessage}</b>
            </div>}
            <div className="newaccounts__body">
                {account.description}
                <Button size='lrg'
                    label={account.button.label}
                    disabled={!account.enabled && !(account.button && account.button.alwaysEnable)}
                    dataAnalyticsItemClicked={account.button.dataAnalytics}
                    onClick={() => window.location.href = account.button.click} />
            </div>
        </div>
    );
};

export default NewAccount;